import { Title3 } from "@components/Typography";
import { Routes } from "@ctypes";
import { useLogout, useModal } from "@hooks";
import { i18n, Translations } from "@i18n";
import { useNavigate } from "react-router-dom";
import { LogoutConfirmationModal } from "./LogoutConfirmationModal";
import { useStyles } from "./styles";

export const LogoutButton = () => {
  const styles = useStyles();

  const { show } = useModal();

  const navigate = useNavigate();
  const { logout } = useLogout();

  const onClick = () => {
    show(
      <LogoutConfirmationModal
        callback={() => {
          logout();
          navigate(Routes.Auth, { replace: true });
        }}
      />,
    );
  };

  return (
    <div style={styles.container} onClick={onClick}>
      <Title3 style={styles.text}>{i18n.t(Translations.ProfileRouteLogoutButtonLabel)}</Title3>
    </div>
  );
};
